import { usePermissionCheck } from '@percent/partner-dashboard/common/hooks/useAllow/usePermissionCheck'
import { POSTHOG_FEATURE_FLAGS, useAuthState, usePostHogFeatureFlag } from '@percent/partner-dashboard/common/hooks'
import { PartnerScopes } from '@percent/partner-dashboard/constants/scopes'
import { selectScopes } from '@percent/partner-dashboard/context/auth'

// Single gate for the organisation directory, shared by the nav and route guards; mirrors what
// pbp-api requires of GET /v1/organisation-profiles (organisation scope + organizations:read).
export const useCanViewOrganisations = (): boolean => {
  const orgProfilesFeatureFlag = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.PD_ORG_PROFILES)
  const { partner } = useAuthState()
  const { userCan } = usePermissionCheck()

  return (
    Boolean(orgProfilesFeatureFlag) &&
    Boolean(selectScopes(partner?.scopes)[PartnerScopes.Organisation]) &&
    userCan('viewOrganisations')
  )
}
